import React from 'react';
import { AdvertorialPage } from './pages/AdvertorialPage';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <AdvertorialPage data-id="element-1" />
    </div>;
}